import { appUrl } from '@/utils/appUrl';

const renderShippingId = (value: string, rowData: any) => {
  const href = appUrl(`/business/shipping/${encodeURIComponent(value)}`);
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <a
        style={{ color: 'var(--primary-color)' }}
        href={href}
        target='_blank'
        rel='noreferrer'
      >
        {value}
      </a>
      {rowData.externalId && (
        <a
          style={{ fontSize: '0.875rem', color: 'var(--primary-color)' }}
          href={href}
          target='_blank'
          rel='noreferrer'
        >
          {rowData.externalId}
        </a>
      )}
    </div>
  );
};

export default renderShippingId;
